// Limits mirror the Decimal(28,9) money and line columns and a promotion's Decimal(5,2) percentage.
export const PROMOTION_CREDIT_CONSTRAINTS = {
    amount: { label: 'Amount', max: 1_000_000_000, decimals: 2 },
    details: { label: 'Details', maxLength: 500 },
    notes: { label: 'Notes', maxLength: 2000 },
    reason: { label: 'Reason', maxLength: 500 },
    lines: { max: 50, decimals: 9, percentageDecimals: 2 },
    reverseIds: { min: 1, max: 100 },
};
//# sourceMappingURL=constraints.js.map